import {
  borderRadius,
  semanticColors,
  shadows
} from '@moderneinc/design-system-tokens';
import { Paper, styled } from '@mui/material';

// Shared by the admin, help, and account top-nav menus. Content-sized to the
// prototype's density; override per-menu via sx if one ever needs a wider floor.
export const TopNavMenuPaper = styled(Paper)({
  minWidth: 210,
  boxShadow: `${shadows.dropdown.x}px ${shadows.dropdown.y}px ${shadows.dropdown.blur}px ${shadows.dropdown.spread}px ${shadows.dropdown.shadow}`,
  border: `1px solid ${semanticColors.color.border.primary}`,
  borderRadius: `${borderRadius.s}px`
});
